import { render, staticRenderFns } from "./Infospots.vue?vue&type=template&id=e3389a52&scoped=true"
import script from "./Infospots.vue?vue&type=script&lang=js"
export * from "./Infospots.vue?vue&type=script&lang=js"
import style0 from "./Infospots.vue?vue&type=style&index=0&id=e3389a52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3389a52",
  null
  
)

export default component.exports